import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../Utils/axiosConfig";

import lichesslogo from "../Assets/Lichess.svg";
import chesscomlogo from "../Assets/Chesscom.svg";
import search from "../Assets/SearchImport.svg";
import info from "../Assets/Info.svg";
import logo from "../Assets/Logo.svg";
export const ImportAccount = () => {
  const [lichessUsername, setLichessUsername] = useState("");
  const [chesscomUsername, setChesscomUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const navigate = useNavigate();

  const checkChesscomUsername = async () => {
    try {
      const response = await fetch(
        `https://api.chess.com/pub/player/${chesscomUsername}`
      );
      const data = await response.json();
      if (data.code === 0) {
        return `Chess.com user "${chesscomUsername}" not found.`;
      } else {
        return "";
      }
    } catch (error) {
      return "Failed to fetch Chess.com user";
    }
  };

  const checkLichessUsername = async () => {
    try {
      const response = await fetch(
        `https://lichess.org/api/user/${lichessUsername}`
      );
      const data = await response.json();
      if (data.error === "Not found") {
        return `Lichess user "${lichessUsername}" not found.`;
      } else {
        return "";
      }
    } catch (error) {
      return "Failed to fetch Lichess user";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setAlertMessage("");

    if (!lichessUsername && !chesscomUsername) {
      setErrorMessage("Enter the username");
      return;
    }

    try {
      const [chesscomError, lichessError] = await Promise.all([
        chesscomUsername ? checkChesscomUsername() : Promise.resolve(""),
        lichessUsername ? checkLichessUsername() : Promise.resolve(""),
      ]);

      if (chesscomError || lichessError) {
        setErrorMessage(chesscomError || lichessError || "Unknown error");
        return;
      }

      const username =
        sessionStorage.getItem("username") || localStorage.getItem("username");

      if (!username) {
        setErrorMessage("No user session found");
        return;
      }

      const response = await axios.post("/external-accounts", {
        username,
        lichessUsername,
        chesscomUsername,
      });

      setAlertMessage("Successfully saved account information");
      setTimeout(() => {
        navigate("/home");
      }, 2000);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      if (error.response && error.response.data) {
        setErrorMessage(
          error.response.data.message || "Failed to save account information"
        );
      } else {
        setErrorMessage("Failed to connect to server");
      }
    }
  };

  useEffect(() => {
    if (alertMessage) {
      setErrorMessage("");
      const alertTimer = setTimeout(() => {
        setAlertMessage("");
      }, 1500);
      return () => clearTimeout(alertTimer);
    } else if (errorMessage) {
      const errorTimer = setTimeout(() => {
        setErrorMessage("");
      }, 1500);
      return () => clearTimeout(errorTimer);
    }
  }, [alertMessage, errorMessage]);
  return (
    <div className="container responsive-page-shell import-account-page">
      <header className="header">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo-text">
          <span className="C-logo">C</span>
          <span className="hezzle-logo">
            he<span className="Z-1">Z</span>
            <span className="Z-2">Z</span>le
          </span>
        </div>
      </header>
      <div className="gradient-line"></div>

      <div className="import-account">
        <div className="import-account-title-row">
          <h2 className="import-account-heading">Import your account</h2>
          <div className="info-svg-div">
            <img src={info} className="info-svg" alt="" />
            <div className="hover-info-import">
              Import your account to get in-depth analysis and specialized
              puzzles from your games.
            </div>
          </div>
        </div>
        <div className="import-desktop-layout">
          <div className="website-import">
            <div className="lichess-logo-div">
              <img src={lichesslogo} className="lichess-logo" alt="" />
              <h3 className="lichess-org">Lichess.org</h3>
            </div>
            <div className="chesscom-logo-div">
              <img src={chesscomlogo} className="chesscom-logo" alt="" />
            </div>
          </div>

          <div className="vertical-line-import"></div>
          <form className="form-import">
            <input
              type="text"
              placeholder="Username"
              className="username-import-lichess"
              onChange={(e) => setLichessUsername(e.target.value)}
            />
            <input
              type="text"
              placeholder="Username"
              className="username-import-chesscom"
              onChange={(e) => setChesscomUsername(e.target.value)}
            />
          </form>
        </div>

        <div className="import-mobile-layout">
          <div className="import-mobile-row">
            <div className="lichess-logo-div">
              <img src={lichesslogo} className="lichess-logo" alt="" />
              <h3 className="lichess-org">Lichess.org</h3>
            </div>
            <input
              type="text"
              placeholder="Username"
              className="username-import-lichess"
              onChange={(e) => setLichessUsername(e.target.value)}
            />
          </div>

          <div className="import-mobile-row">
            <div className="chesscom-logo-div">
              <img src={chesscomlogo} className="chesscom-logo" alt="" />
            </div>
            <input
              type="text"
              placeholder="Username"
              className="username-import-chesscom"
              onChange={(e) => setChesscomUsername(e.target.value)}
            />
          </div>
        </div>
        <button onClick={handleSubmit} className="confirm-and-proceed-button">
          Confirm & proceed{" "}
          <img src={search} alt="" className="search-import-svg" />
        </button>
        <span
          className="continue-anyway"
          aria-disabled="true"
          style={{
            opacity: 0.4,
            pointerEvents: "none",
            cursor: "not-allowed",
          }}
        >
          Continue anyway?
        </span>
        {errorMessage && <p className="error-message-import">{errorMessage}</p>}
        {alertMessage && <p className="alert-message-import">{alertMessage}</p>}
      </div>
    </div>
  );
};
